import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

export interface MainScreenImage {
  id?: number;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class MainScreenImageService {
  private baseUrl = `${environment.apiUrl}/admin/main-screen-images`;

  constructor(private http: HttpClient) {}

  getList(): Observable<MainScreenImage[]> {
    return this.http.get<MainScreenImage[]>(this.baseUrl);
  }

  getById(id: number): Observable<MainScreenImage> {
    return this.http.get<MainScreenImage>(`${this.baseUrl}/${id}`);
  }

  save(image: MainScreenImage): Observable<MainScreenImage> {
    return this.http.post<MainScreenImage>(this.baseUrl, image);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
